import View from '@shared/components/layout-default/layout-default-router-view';

export const phone_number = [
  {
    path: 'phone-number',
    component: View,
    children: [
      {
        path: '',
        name: 'phone-number.index',
        redirect: {
          name: 'phone-number.number.index'
        }
      },

      {
        path: 'numbers',
        component: View,
        children: [
          {
            path: '',
            name: 'phone-number.number.index',
            component: () =>
              import(
                /* webpackChunkName: 'phone-number' */
                '@phone-number/pages/numbers-list-page'
              ),
            meta: {
              title: {
                code: 'phone-number.breadcrumb.number.index'
              }
            }
          },

          {
            path: 'buy',
            name: 'phone-number.number.buy',
            component: () =>
              import(
                /* webpackChunkName: 'phone-number' */
                '@phone-number/pages/numbers-buy-page'
              ),
            meta: {
              title: {
                code: 'phone-number.breadcrumb.number.buy'
              }
            }
          }
        ]
      },

      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'phone-number.stats.index',
            redirect: {
              name: 'phone-number.stats.type',
              params: {
                type: 'general',
                number: ''
              }
            }
          },
          {
            path: ':type(general|detailed)',
            name: 'phone-number.stats.type',
            component: () =>
              import(
                /* webpackChunkName: 'mailer-mailings' */
                '@phone-number/pages/phone-number-stats-page'
              ),
            meta: {
              title: {
                code: 'shared.breadcrumb.stats.title'
              }
            }
          }
        ]
      }
    ]
  }
];
